<div class="a00300">
    <div class="a00300-container" [ngClass]="{'a00300-center': data?.position == 'CENTER', 'a00300-left': data?.position == 'LEFT', 'a00300-right': data?.position == 'RIGHT'}">
        <p *ngIf="data?.text">{{data?.text}}</p>
    </div>
</div>
